import { useTranslation } from 'react-i18next'

import { Button } from '@/Atomic/Molecules/Button'
import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import DropdownMenu from '@/Atomic/Organisms/DropdownMenu'
import { DrawerHeader } from '@/Atomic/Templates/Drawer'

interface DocumentDrawerHeaderProps {
  handleClose: () => void
  handleNavigate: (id?: string) => void
  previousId?: string
  nextId?: string
  isEditing: boolean
  setIsEditing: (isEditing: boolean) => void
  openDrawerId?: (id?: string | undefined) => void
  menuItems: MenuItemProps[]
}
export const DocumentDrawerHeader: React.FC<DocumentDrawerHeaderProps> = ({
  handleClose,
  handleNavigate,
  previousId,
  nextId,
  isEditing,
  setIsEditing,
  openDrawerId,
  menuItems,
}) => {
  const { t } = useTranslation()

  return (
    <DrawerHeader>
      <div className="header item">
        <Button
          variant="icon"
          icon="cross"
          tooltip={t('tooltip.close')}
          onClick={handleClose}
        />
        <Button
          variant="icon"
          icon="chevron-up"
          tooltip={t('tooltip.previous')}
          onClick={() => handleNavigate(previousId)}
          disabled={!previousId || isEditing}
          hidden={!openDrawerId}
        />
        <Button
          variant="icon"
          icon="chevron-down"
          tooltip={t('tooltip.next')}
          onClick={() => handleNavigate(nextId)}
          disabled={!nextId || isEditing}
          hidden={!openDrawerId}
        />
      </div>
      <div className="header item">
        <Button
          variant="icon"
          icon="edit"
          tooltip={t('tooltip.edit')}
          onClick={() => setIsEditing(true)}
          disabled={isEditing}
        />
        <DropdownMenu
          className="document-drawer-dropdown"
          menuItems={menuItems}
          disabled={isEditing}
        />
      </div>
    </DrawerHeader>
  )
}
